export const SHOW_FORM = 'SHOW_FORM';
export const GET_PROJECTS = 'GET_PROJECTS';
export const ADD_PROJECT = 'ADD_PROJECT';
export const VALIDATE_FORM = 'VALIDATE_FORM';
export const CURRENT_PROJECT = 'CURRENT_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const PROJECT_ERROR = 'PROJECT_ERROR';
export const RESET_PROJECT_STATE = 'RESET_PROJECT_STATE';

export const PROJECT_TASKS = 'PROJECT_TASKS';
export const ADD_TASK = 'ADD_TASK';
export const VALIDATE_TASK = 'VALIDATE_TASK';
export const DELETE_tASK = 'DELETE_TASK';
export const CURRENT_TASK = 'CURRENT_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const CLEAN_TASK = 'CLEAN_TASK';
export const RESET_TASK_STATE = 'RESET_TASK_STATE'

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const SUCCESSFUL_REGISTRATION = 'SUCCESSFUL_REGISTRATION';
export const REGISTRATION_ERROR = 'REGISTRATION_ERROR';
export const GET_USER = 'GET_USER';
export const SUCCESSFUL_LOGIN = 'SUCCESSFUL_LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const SIGN_OFF = 'SIGN_OFF';